import { Box } from "@mui/material";
import TokenLogo from "../TokenLogo";

// the two logos of a pool, the second one overlapping the first
const PairLogos = ({ tokens, size = 32 }) => (
  <Box sx={{ display: "flex", flexShrink: 0 }}>
    {tokens.map((token, index) => (
      <TokenLogo
        key={index}
        token={token}
        size={size}
        sx={{ ml: index ? `-${Math.round(size * 0.3)}px` : 0, border: 2, borderColor: "background.paper" }}
      />
    ))}
  </Box>
);

export default PairLogos;
